import React from 'react';
export function ShuffleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5.968V3l5 4-5 4V8h-3.879l-9.707 9.707L2 16.293 6.293 12 2 7.707l1.414-1.414 4.293 4.293 4-4A2 2 0 0113.121 6H17v-.032zm0 10V13l5 4-5 4v-3h-3.879a2 2 0 01-1.414-.586L9 14.707l1.414-1.414L13.121 16H17v-.032z"
  }));
}